<template>
    <Teleport to="body">
        <Transition>
            <div
                @click.self="close"
                v-show="show"
                class="fixed inset-0 bg-black/40 flex items-center justify-center p-10 z-[9999] uses-tailwind"
            >
                <div
                    class="bg-white max-w-full max-h-full w-full sm:w-auto sm:min-w-[500px] lg:min-w-[800px] flex flex-col relative"
                >
                    <div
                        v-if="loading"
                        class="absolute inset-0 bg-white flex items-center justify-center z-[9999]"
                    >
                        <spinner-text
                            style="
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                gap: 10px;
                            "
                        >
                            {{ loadingText }}
                        </spinner-text>
                    </div>
                    <div v-if="$slots.header" class="flex-shrink-0">
                        <div class="border-b">
                            <slot name="header" />
                        </div>
                    </div>
                    <div
                        v-else
                        :class="{ 'border-b': title && title.length }"
                        class="flex items-stretch justify-between h-[60px] flex-shrink-0"
                    >
                        <p class="self-center px-5 text-xl font-bold">
                            {{ title }}
                        </p>
                        <button
                            @click="close"
                            class="p-5 text-lg transition-all bg-white cursor-pointer hover:bg-slate-100 aspect-square"
                        >
                            <i class="fa fa-times"></i>
                        </button>
                    </div>
                    <div class="px-5 py-5 overflow-y-auto flex-1">
                        <slot />
                    </div>
                    <div v-if="$slots.footer" class="border-t flex-shrink-0">
                        <slot name="footer" />
                    </div>
                    <div
                        v-else
                        class="flex items-center justify-end gap-2 px-5 pb-5 border-t flex-shrink-0"
                    >
                        <button
                            v-for="(action, index) in actions"
                            :key="index"
                            @click="action.handler()"
                            class="h-[50px] px-5 rounded-lg transition-all cursor-pointer text-lg"
                            :class="{
                                'bg-primary hover:bg-primary-dark text-white':
                                    action.theme === 'primary',
                                'bg-white hover:bg-zinc-100 text-black':
                                    !action.hasOwnProperty('theme'),
                            }"
                        >
                            {{ action.label }}
                        </button>
                    </div>
                </div>
            </div>
        </Transition>
    </Teleport>
</template>

<script>
import SpinnerText from '../loader/SpinnerText';
import Teleport from 'vue2-teleport';

export default {
    name: 'Modal',
    components: {
        Teleport,
        SpinnerText,
    },
    props: {
        show: {
            type: Boolean,
            required: true,
        },
        loading: {
            type: Boolean,
            required: false,
            default: false,
        },
        loadingText: {
            type: String,
            required: false,
        },
        title: {
            type: String,
            required: false,
        },
        actions: {
            type: Array,
            required: false,
        },
        freezeBody: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    watch: {
        show: {
            handler(value) {
                if (value) {
                    this.lockBody();
                } else {
                    this.unlockBody();
                }
            },
            immediate: true,
        },
    },
    beforeDestroy() {
        this.unlockBody();
    },
    methods: {
        lockBody() {
            if (this.freezeBody) {
                document.body.style.overflow = 'hidden';
            }
        },
        unlockBody() {
            document.body.style.overflow = 'auto';
        },
        close() {
            this.$emit('close');
        },
    },
};
</script>
